import { ContainerPlugin, Events, Log } from 'clappr'
import { get } from 'lodash'

export default class ClapprStatsLite extends ContainerPlugin {
    get name() { return 'clappr_stats_Lite' }

    get _playbackName() { return this.container.playback.name }
    get _playbackType() { return this.container.getPlaybackType() }
    _now() {
        const hasPerformanceSupport = window.performance && typeof (window.performance.now) === 'function'
        return (hasPerformanceSupport) ? window.performance.now() : new Date()
    }
    _inc(counter) { this._metrics.counters[counter] += 1 }
    _timerHasStarted(timer) { return this[`_start${timer}`] !== undefined }
    _start(timer) { this[`_start${timer}`] = this._now() }
    _stop(timer) { this._metrics.timers[timer] += this._now() - this[`_start${timer}`] }
    _defaultReport(metrics) { console.log(metrics) } //eslint-disable-line no-console

    constructor(container) {
        super(container)
        this._onReport = get(container, 'options.clapprStatsLite.onReport', this._defaultReport)
        

        this._completion = {
            watch: get(container, 'options.clapprStatsLite.onCompletion', []),
            calls: []
        }

        this._newMetrics()
        this.on(ClapprStatsLite.REPORT_EVENT, this._onReport)
    }

    bindEvents() {
        this.listenTo(this.container, Events.CONTAINER_BITRATE, this.onBitrate)
        this.listenTo(this.container, Events.CONTAINER_STOP, this.stopReporting)
        this.listenTo(this.container, Events.CONTAINER_ENDED, this.stopReporting)
        this.listenToOnce(this.container.playback, Events.PLAYBACK_PLAY_INTENT, this.startTimers)
        this.listenToOnce(this.container, Events.CONTAINER_PLAY, this.onFirstPlaying)
        this.listenTo(this.container, Events.CONTAINER_PLAY, this.onPlay)
        this.listenTo(this.container, Events.CONTAINER_PAUSE, this.onPause)
        this.listenToOnce(this.container, Events.CONTAINER_STATE_BUFFERING, this.onBuffering)
        this.listenTo(this.container, Events.CONTAINER_SEEK, this.onSeek)
        this.listenTo(this.container, Events.CONTAINER_ERROR, () => this._inc('error'))
        this.listenTo(this.container, Events.CONTAINER_FULLSCREEN, () => this._inc('fullscreen'))
        this.listenTo(this.container, Events.CONTAINER_PLAYBACKDVRSTATECHANGED, (dvrInUse) => { dvrInUse && this._inc('dvrUsage') })
        this.listenTo(this.container.playback, Events.PLAYBACK_PROGRESS, this.onProgress)
        this.listenTo(this.container.playback, Events.PLAYBACK_TIMEUPDATE, this.onTimeUpdate)
    }

    destroy() {
        this.stopReporting()
        super.destroy()
    }

    onBitrate(newBitrate) {
        var bitrate = parseInt(get(newBitrate, 'bitrate', 0), 10)
        var now = this._now()

        if (this._metrics.extra.bitratesHistory.length > 0) {
            var beforeLast = this._metrics.extra.bitratesHistory[this._metrics.extra.bitratesHistory.length - 1]
            beforeLast.end = now
            beforeLast.time = now - beforeLast.start
        }

        this._metrics.extra.bitratesHistory.push({ start: this._now(), bitrate: bitrate })

        this._inc('changeLevel')
    }

    stopReporting() {
        this._buildReport()

        // clearInterval(this._intervalId)
        this._newMetrics()

        this.stopListening()
        this.bindEvents()
    }

    startTimers() {
        // this._intervalId = setInterval(this._buildReport.bind(this), this._runEach)
        this._start('session')
        this._start('startup')
    }

    onFirstPlaying() {
        this.listenTo(this.container, Events.CONTAINER_TIMEUPDATE, this.onContainerUpdateWhilePlaying)

        this._start('watch')
        this._stop('startup')
    }

    playAfterPause() {
        this.listenTo(this.container, Events.CONTAINER_TIMEUPDATE, this.onContainerUpdateWhilePlaying)
        this._stop('pause')
        this._start('watch')
    }

    onPlay() {
        this._inc('play')
    }

    onPause() {
        this._stop('watch')
        this._start('pause')
        this._inc('pause')
        this.listenToOnce(this.container, Events.CONTAINER_PLAY, this.playAfterPause)
        this.stopListening(this.container, Events.CONTAINER_TIMEUPDATE, this.onContainerUpdateWhilePlaying)
    }

    onSeek(e) {
        this._inc('seek')
        this._metrics.extra.watchHistory.push([e * 1000, e * 1000])
    }

    onTimeUpdate(e) {
        var current = e.current * 1000,
            total = e.total * 1000,
            l = this._metrics.extra.watchHistory.length

        this._metrics.extra.duration = total
        this._metrics.extra.currentTime = current
        this._metrics.extra.watchedPercentage = (current / total) * 100

        if (l === 0) {
            this._metrics.extra.watchHistory.push([current, current])
        } else {
            this._metrics.extra.watchHistory[l - 1][1] = current
        }

        if (this._metrics.extra.bitratesHistory.length > 0) {
            var lastBitrate = this._metrics.extra.bitratesHistory[this._metrics.extra.bitratesHistory.length - 1]
            if (!lastBitrate.end) {
                lastBitrate.time = this._now() - lastBitrate.start
            }
        }

        this._onCompletion()
    }

    onContainerUpdateWhilePlaying() {
        if (this.container.playback.isPlaying()) {
            this._stop('watch')
            this._start('watch')
        }
    }

    onBuffering() {
        this._inc('buffering')
        this._start('buffering')
        this.listenToOnce(this.container, Events.CONTAINER_STATE_BUFFERFULL, this.onBufferfull)
    }

    onBufferfull() {
        this._stop('buffering')
        this.listenToOnce(this.container, Events.CONTAINER_STATE_BUFFERING, this.onBuffering)
    }

    onProgress(progress) {
        this._metrics.extra.buffersize = progress.current * 1000
    }

    _newMetrics() {
        this._metrics = {
            counters: {
                play: 0, pause: 0, error: 0, buffering: 0, decodedFrames: 0, droppedFrames: 0,
                fps: 0, changeLevel: 0, seek: 0, fullscreen: 0, dvrUsage: 0
            },
            timers: {
                startup: 0, watch: 0, pause: 0, buffering: 0, session: 0, latency: 0
            },
            extra: {
                playbackName: '', playbackType: '', bitratesHistory: [], bitrateWeightedMean: 0,
                bitrateMostUsed: 0, buffersize: 0, watchHistory: [], watchedPercentage: 0,
                bufferingPercentage: 0, bandwidth: 0, duration: 0, currentTime: 0
            }
        }
    }

    _onCompletion() {
        let currentPercentage = this._metrics.extra.watchedPercentage
        let allPercentages = this._completion.watch
        let isCalled = this._completion.calls.indexOf(currentPercentage) != -1

        if (allPercentages.indexOf(currentPercentage) != -1 && !isCalled) {
            Log.info(this.name + ' PERCENTAGE_EVENT: ' + currentPercentage)
            this._completion.calls.push(currentPercentage)
            this.trigger(ClapprStatsLite.PERCENTAGE_EVENT, currentPercentage)
        }
    }

    _buildReport() {
        this._stop('session')
        this._start('session')

        this._metrics.extra.playbackName = this._playbackName
        this._metrics.extra.playbackType = this._playbackType

        this.trigger(ClapprStatsLite.REPORT_EVENT, JSON.parse(JSON.stringify(this._metrics)))
    }

}

ClapprStatsLite.REPORT_EVENT = 'clappr:stats:lite:report'
ClapprStatsLite.PERCENTAGE_EVENT = 'clappr:stats:lite:percentage'



// WEBPACK FOOTER //
// ./src/components/ClapprPlayer/ClapprStatsLite.js